import { inject, Injectable } from '@angular/core';
import {
  type CreateDashboardRoleInput,
  type DashboardRoleFragmentFragment,
  type DestroyDashboardRoleInput,
  type FindOrCreateUserWithDashboardRoleAndWorkspaceRolesInput,
  type UpdateDashboardRoleInput,
} from '@reconcept-platform/shared/types';
import { DashboardRoleApi } from '../../api/dashboard-role/dashboard-role-api.service';
import { DashboardRoleAccessLevelEnum } from '../../schema/schema-enums';

export function determineIsLastManageDashboardRole(role: DashboardRoleFragmentFragment): boolean {
  if (role.accessLevel === DashboardRoleAccessLevelEnum.MANAGE) {
    return (
      role.dashboard.dashboardRoles.edges
        .map((it) => it.node)
        // @ts-expect-error TS18049 possibly null or undefined
        .map((otherRole) => otherRole.accessLevel)
        .filter((accessLevel: DashboardRoleAccessLevelEnum) => accessLevel === DashboardRoleAccessLevelEnum.MANAGE)
        .length === 1
    );
  } else {
    return false;
  }
}

@Injectable({
  providedIn: 'root',
})
export class DashboardRoleService {
  private dashboardRoleApi = inject(DashboardRoleApi);

  watchDashboardRole(roleId: string) {
    return this.dashboardRoleApi.watchDashboardRole(roleId);
  }

  createDashboardRole(createDashboardRoleInput: CreateDashboardRoleInput) {
    return this.dashboardRoleApi.createDashboardRole(createDashboardRoleInput);
  }

  createUserWithDashboardRoleAndWorkspaceRoles(input: FindOrCreateUserWithDashboardRoleAndWorkspaceRolesInput) {
    return this.dashboardRoleApi.createUserWithDashboardRoleAndWorkspaceRoles(input);
  }

  updateDashboardRole(updateDashboardRoleInput: UpdateDashboardRoleInput) {
    return this.dashboardRoleApi.updateDashboardRole(updateDashboardRoleInput);
  }

  destroyDashboardRole(destroyDashboardRoleInput: DestroyDashboardRoleInput, dashboardId: string) {
    return this.dashboardRoleApi.destroyDashboardRole(destroyDashboardRoleInput, dashboardId);
  }
}
